import { styled } from '@linaria/react';

import { SubHeadline, Text } from '~components/Typography';
import { truncateString } from '~theme/snippets';

export const Container = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	border-radius: var(--radius-xs);
	-webkit-transform: translate3d(0, 0, 0);

	&.active {
		background-color: var(--color-white-xs);
		cursor: default;
		pointer-events: none;
		transition: background-color 0.4s;
	}

	&::after {
		position: absolute;
		z-index: -1;
		top: 5px;
		left: 5px;
		display: block;
		width: 48px;
		height: 48px;
		border-radius: 100%;
		background: var(--blur-bg);
		content: '';
		filter: blur(10px);
		opacity: 1;
		transform-origin: left center;
		transition: filter 0.2s, transform 0.2s, opacity 0.2s;
	}

	&:not(.active) {
		&::after {
			filter: blur(28px);
			opacity: 0;
			transform: scaleX(2.4) translateX(10px);
		}

		@media (hover: hover), (-moz-touch-enabled: 0), (pointer: fine) {
			&:hover {
				&::after {
					opacity: 1;
				}
			}
		}
	}
`;

export const PhotoBox = styled.div`
	padding: 5px;
`;

export const InfoBox = styled.div`
	width: 0;
	flex: 1 0 auto;
	padding: 8px 16px 8px 8px;
`;

export const TopRow = styled.div`
	display: flex;
	align-items: center;
	gap: var(--gap-s);
`;

export const BottomRow = styled.div`
	display: flex;
	align-items: center;
	gap: var(--gap-s);
`;

export const Name = styled(SubHeadline)`
	${truncateString};
`;

export const Message = styled(Text)<{
	isSexting?: boolean;
	isUnread?: boolean;
}>`
	${truncateString}

	flex: 1;
	color: ${({ isSexting, isUnread }) =>
		isSexting
			? 'var(--color-white-solid)'
			: isUnread
			? 'var(--color-grey-68-solid)'
			: 'var(--color-grey-46-solid)'};
	line-height: var(--line-height-text-m);
	text-shadow: ${({ isSexting }) =>
		isSexting ? '0 1px 7px var(--color-rose-48-solid)' : 'none'};
	transition: color 0.2s;
`;

export const PlaceholderWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 18px;
	margin-top: 2px;
`;
